var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.344 250.344C-0.781 253.469 -0.781 258.531 2.344 261.656L154.344 413.656C155.906 415.219 157.937 416 160 416S164.094 415.219 165.656 413.656C168.781 410.531 168.781 405.469 165.656 402.344L27.312 264H344C348.406 264 352 260.422 352 256S348.406 248 344 248H27.312L165.656 109.656C168.781 106.531 168.781 101.469 165.656 98.344S157.469 95.219 154.344 98.344L2.344 250.344ZM432 72V440C432 444.418 435.582 448 440 448S448 444.418 448 440V72C448 67.582 444.418 64 440 64S432 67.582 432 72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftFromLine);
export default __webpack_public_path__ + "static/media/arrow-left-from-line.c32c2b4f6ee493b21de2455a06f48caa.svg";
export { ForwardRef as ReactComponent };